import { ChangeEvent, ReactNode } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Input } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';
import { matchesSVG } from 'utils/strings';

interface Props {
  avatar: ReactNode;
  editing?: boolean;
  name: ReactNode;
  setName?: (name: string) => void;
  summary?: string;
}

export const MediaDisplay = ({ avatar, name, summary, editing, setName }: Props) => {
  const { t } = useTranslation('common');
  const isSvg = matchesSVG(avatar);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (setName) {
      setName(e.target.value);
    }
  };

  return (
    <div className='media-display-container'>
      <div className='avatar-container large'>
        {isSvg ?
          <img alt={t('general.logo')} className='avatar' src={avatar as string}/> :
          <UserOutlined className='avatar' />
        }
      </div>
      <div className='body'>
        { editing && setName ? 
          <Input onChange={handleInputChange} value={name} /> :
          <div className='name'>{name}</div>
        }

        {!!summary && <div className='summary'>{summary}</div>}
      </div>
    </div>
  );
};
